import React from "react";

const BS5_Buttons = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Buttons Component</h2>
      <p>This is the BS5_Buttons component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Buttons;
